import React from 'react';
import { Mail } from 'lucide-react';
import { LoadingSpinner } from './LoadingSpinner';
import { usePdfMailShare, type SharePdfByMailOptions } from '../features/inbox/PdfMailShareProvider';

type Props = SharePdfByMailOptions & {
  /** `label`: „Per E-Mail senden“ mit Icon; `icon`: nur Icon. */
  variant?: 'label' | 'icon';
  className?: string;
};

/** Öffnet das Mail-Fenster mit dem PDF als Anhang (siehe `PdfMailShareProvider`). */
export function PdfMailShareButton({ variant = 'label', className, ...opts }: Props) {
  const mailShare = usePdfMailShare();
  const [busy, setBusy] = React.useState(false);
  if (!mailShare) return null;

  const onClick = async (event: React.MouseEvent) => {
    event.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      await mailShare.sharePdfByMail(opts);
    } finally {
      setBusy(false);
    }
  };

  const title = 'Per E-Mail senden';
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      title={title}
      aria-label={title}
      className={`disabled:cursor-wait ${className ?? ''}`.trim()}
    >
      {busy ? <LoadingSpinner size="sm" /> : <Mail className="h-4 w-4" aria-hidden />}
      {variant === 'label' ? <span>{title}</span> : null}
    </button>
  );
}
